import React, { useState, useEffect, useRef } from "react";
import { Button } from "components/Button/Button.styled";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTable } from "@fortawesome/free-solid-svg-icons";
import DropdownMenu from "./DropdownMenu";
import { DropdownButtonProps } from "./Dropdown.interface";
import { DropdownContainer } from "./Dropdown.styled";

const DropdownButton: React.FC<DropdownButtonProps> = ({
  columns,
  visibleColumns,
  toggleColumnVisibility,
}) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = (event: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      setShowDropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <DropdownContainer ref={dropdownRef}>
      <Button
        className="btn btn-primary"
        onClick={() => setShowDropdown(!showDropdown)}
        data-testid="column-visibility-button" // Adding data-testid here
      >
        <FontAwesomeIcon icon={faTable} />
      </Button>
      {showDropdown && (
        <DropdownMenu
          columns={columns}
          visibleColumns={visibleColumns}
          toggleColumnVisibility={toggleColumnVisibility}
        />
      )}
    </DropdownContainer>
  );
};

export default DropdownButton;
